:host {
  display: block;
}

.spw-textarea {
  position: relative;
  &__input {
    flex: 1;
    width: 100%;
    min-height: 40px;
    padding: 12px;
    resize: vertical;
    border-radius: 4px;
    border: 1px solid var(--spw-color-themes-grey-grey-800);
    &:hover {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }
    &:focus,
    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }
    .spw-textarea--disabled & {
      border-color: var(--spw-color-themes-grey-grey-400);
      background: var(--spw-color-themes-grey-grey-100);
      color: var(--spw-color-themes-grey-grey-500);
      cursor: not-allowed;
      &::placeholder {
        color: var(--spw-color-themes-grey-grey-500);
      }
      &:hover,
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
    .spw-textarea--is-error & {
      border-color: var(--spw-colors-states-error-error-300);
    }
    .spw-textarea--large & {
      height: 60px;
      padding: 0 24px;
      line-height: 60px;
    }
    .spw-textarea--is-search & {
      padding-right: 80px;
    }
  }
  &__container {
    display: flex;
    align-items: center;
  }
  &__indicator {
    @apply spw-tw-pl-3;
  }
  &__icon {
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    color: var(--spw-ds-primary);
    font-size: 24px;
  }
}
